import state from './budgets.state'
import mutations from './budgets.mutations'
import actions from './budgets.actions'
import getters from './budgets.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
